import { Component, OnInit } from '@angular/core';
import { Utility } from 'src/app/core/common';
import { JobService } from 'src/app/services/job.service';

@Component({
  selector: 'app-manage-job-advertise',
  templateUrl: './manage-job-advertise.component.html',
  styleUrls: ['./manage-job-advertise.component.scss']
})
export class ManageJobAdvertiseComponent implements OnInit {

  constructor(private jobService: JobService) { }

  async ngOnInit() {
    await this.load();
  }

  advertises: any[];
  async load() {
    this.advertises = await this.jobService.getAdvertises();
  }

  advertise: any;
  open(advertise?: any) {
    this.advertise = Utility.clone(advertise || { Criteria: {} });
  }

  async save(advertise?: any) {
    let res = await this.jobService.saveAdvertise(advertise || this.advertise);
    if(res)
      this.advertises = this.advertises.map(_ => _.Id == res.Id ? res : _);
    if (!advertise) this.advertise = null;
  }
}
